var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaOkhotaVyzovFld2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D03B2F",
    d: "M8.143 7.797A11.622 11.622 0 0 0 5.99 11.02l4.054-1.032-4.633 2.534-4.13 2.271 3.817-.977c-.082.448-.139.9-.168 1.356a12.01 12.01 0 0 0 1.975 7.473l5.213-1.33-4.402 2.441-4.332 2.388 5.322-1.368a10.686 10.686 0 0 0 4.877 2.57v-8.04l-4.975 1.275 4.975-2.741v-1.832h-4.82l6.371-11.601c-2.641.206-5.123 1.41-6.99 3.389Zm22.577 9.494-3.834.977c.09-.471.153-.948.185-1.428.187-2.787-.586-5.552-2.178-7.785a1.825 1.825 0 0 0-.127-.171l-6.15 1.581 5.096-2.809 3.631-2.002-4.552 1.16a10.755 10.755 0 0 0-4.379-2.131v9.006l5.08-1.295-5.08 2.803v.8h4.82l-.54.977-5.791 10.618c1.925-.15 3.78-.83 5.377-1.973A11.45 11.45 0 0 0 26 21.077l-4.008 1.026 4.575-2.522 4.153-2.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaOkhotaVyzovFld2);
export default __webpack_public_path__ + "static/media/russia_okhota_vyzov_fld_2.945304d14974b282f836f010b7f1ab9a.svg";
export { ForwardRef as ReactComponent };